(function () {
    'use strict';
    angular.module('Services').factory('RPJobAssignmentTable', RPJobAssignmentTable);
    RPJobAssignmentTable.$inject = [
        'TableLiteFactory',
        'toastr',
        'FleetService',
        'TypeStatusConsts',
        'Units',
        '$rootScope',
        '$filter',
        '$uibModal',
        'ClientService',
        '$q',
        'ScanSummaryHelperService'
    ];

    function RPJobAssignmentTable(
        TableLiteFactory,
        toastr,
        FleetService,
        TypeStatusConsts,
        Units,
        $rootScope,
        $filter,
        $uibModal,
        ClientService,
        $q,
        ScanSummaryHelperService
    ) {
        return function (offices) {
            const { jobType, jobTypeValue, jobStatuses, jobStatusesValue } = TypeStatusConsts;
            const defaultFilters = {};

            const tableData = {
                tableName: 'RPCrossDockJobsTable',
                optionAddOns: {
                    buttons: [{
                        class: 'btn-primary',
                        label: 'Plan Route',
                        onClick: () => {
                            const selectedJobs = tableData.data.filter(job => job.isSelected);
                            if (selectedJobs.length < 1) { return; }
                            $uibModal.open({
                                animation: true,
                                ariaLabelledBy: 'modal-title',
                                ariaDescribedBy: 'modal-body',
                                templateUrl: '/templates/pages/route-planning/modal/route-planning-modal.html',
                                controller: 'RoutePlanningModalController',
                                controllerAs: 'vm',
                                size: 'lg',
                                appendTo: $('body'),
                                resolve: {
                                    jobs: () => selectedJobs,
                                    id: () => null
                                }
                            });
                        }
                    }],
                    checkBoxes: [
                        {
                            label: 'SHOW ALL JOBS',
                            ngModel: false,
                            onChange: function (checked) {
                                tableActions.sendRequest(angular.extend(defaultFilters, { showPartialScanned: checked }));
                            }
                        }
                    ],
                    selectFilters: [
                        {
                            label: 'Office',
                            ngModel: { label: 'N/A' },
                            width: '150px',
                            dropDownIsFetching: false,
                            selectChoices: [],
                            getChoicesData: function (search) {
                                const sortedOffices = offices.sort((a, b) => a.name.localeCompare(b.name));
                                this.selectChoices = sortedOffices
                                    .filter(itm => itm.name.toLowerCase()
                                        .includes(search.toLowerCase()))
                                    .map(itm => ({ label: itm.name, officeId: itm.id }));
                            },
                            onSelect: function (selected) {
                                tableActions.sendRequest(angular.extend(defaultFilters, { officeId: selected.officeId }));
                            }
                        },
                        {
                            label: 'Company',
                            ngModel: { label: 'N/A' },
                            dropDownIsFetching: false,
                            selectChoices: [],
                            width: '150px',
                            getChoicesData: function (search) {
                                this.dropDownIsFetching = true;
                                ClientService.Company.getAll((data) => {
                                    this.selectChoices = data.content.map(i => {
                                        return { label: i.name, companyId: i.id };
                                    });
                                    this.selectChoices.push({ label: 'N/A' });
                                }, error => {
                                    this.dropDownIsFetching = false;
                                    toastr.error('Error', error.message);
                                }, { name: search });
                            },
                            onSelect: function (selected) {
                                tableActions.sendRequest(angular.extend(defaultFilters, { companyId: selected.companyId }));
                            }
                        }
                    ]
                },
                config: {
                    noPagination: false,
                    noHeaders: false,
                    noItemsView: false,
                    noTableFooter: false
                },
                headers: [
                    {
                        label: 'SELECT',
                        class: 'text-center',
                        filter: {
                            type: 'checkbox'
                        }
                    },
                    {
                        label: 'DATE & TIME',
                        viewName: 'dateTime',
                        filterName: 'createdDate',
                        filter: {
                            type: 'datePicker',
                            url: '',
                            class: 'filter-date',
                            toModel: '',
                            fromModel: '',
                            useArray: true,
                            onSubmit: function (header) {
                                tableActions.sendRequest(tableActions.evaluateFilter(header));
                            }
                        },
                        headerFn: function () {
                            tableActions.sort(this.filterName);
                        }
                    },
                    {
                        label: 'Company',
                        width: '200px',
                        viewName: 'companyName',
                        filterName: 'companyId',
                        filter: {
                            type: 'autoComplete',
                            placeholder: 'Search',
                            viewName: 'name',
                            filterBy: 'id',
                            items: [],
                            onSubmit: function (header) {
                                tableActions.sendRequest(tableActions.evaluateFilter(header));
                            },
                            refresh: function (model) {
                                const defer = $q.defer();
                                let filterItems = this.items;
                                ClientService.Company.getAll((data) => {
                                    filterItems.length = 0;
                                    angular.forEach(data.content, (vehicle) => {
                                        filterItems.push(vehicle);
                                    });
                                    defer.resolve();
                                }, (error) => {
                                    defer.reject();
                                }, { size: 30, name: model });
                                return defer.promise;
                            }
                        },
                        headerFn: function () {
                            tableActions.sort(this.filterName);
                        }
                    },
                    {
                        label: 'JOB ID',
                        viewName: 'jobId',
                        filterName: 'jobId',
                        filter: {
                            type: 'text',
                            onSubmit: function (header) {
                                tableActions.sendRequest(tableActions.evaluateFilter(header));
                            }
                        },
                        headerFn: function () {
                            tableActions.sort(this.filterName);
                        }
                    },
                    {
                        label: 'Batch ID',
                        viewName: 'batchFormatted',
                        filterName: 'batchId',
                        headerFn: function () {
                            tableActions.sort(this.filterName);
                        }
                    },
                    {
                        label: 'Sort Code',
                        viewName: 'sortCode',
                        filterName: 'route.area.sortCode',
                        filter: {
                            type: 'text',
                            viewName: 'sortCode',
                            onSubmit: function (header) {
                                tableActions.sendRequest(tableActions.evaluateFilter(header));
                            }
                        },
                        headerFn: function () {
                            tableActions.sort(this.sortName);
                        }
                    },
                    {
                        label: 'PACKAGES SCANNED',
                        viewName: 'scanSummary'
                    },
                    {
                        label: 'STATUS',
                        viewName: 'jobStatusFormatted',
                        filterName: 'jobStatus',
                        filter: {
                            type: 'select2',
                            placeholder: 'Search',
                            items: [{
                                value: jobStatusesValue.unassigned,
                                viewName: jobStatuses[jobStatusesValue.unassigned.toLowerCase()]
                            }, {
                                value: jobStatusesValue.forapproval,
                                viewName: jobStatuses[jobStatusesValue.forapproval.toLowerCase()]
                            }, {
                                value: jobStatusesValue.pending,
                                viewName: jobStatuses[jobStatusesValue.pending.toLowerCase()]
                            }, {
                                value: jobStatusesValue.accepted,
                                viewName: jobStatuses[jobStatusesValue.accepted.toLowerCase()]
                            }, {
                                value: jobStatusesValue.received,
                                viewName: jobStatuses[jobStatusesValue.received.toLowerCase()]
                            }, {
                                value: jobStatusesValue.inprogress,
                                viewName: jobStatuses[jobStatusesValue.inprogress.toLowerCase()]
                            }, {
                                value: jobStatusesValue.delivered,
                                viewName: jobStatuses[jobStatusesValue.delivered.toLowerCase()]
                            }, {
                                value: jobStatusesValue.failed,
                                viewName: jobStatuses[jobStatusesValue.failed.toLowerCase()]
                            }, {
                                value: jobStatusesValue.notyetstarted,
                                viewName: jobStatuses[jobStatusesValue.notyetstarted.toLowerCase()]
                            }],
                            onSelect: function (header) {
                                const filter = {};
                                filter[header.filterName] = header.filter.model;
                                tableActions.sendRequest(filter);
                            }
                        },
                        headerFn: function () {
                            tableActions.sort(this.filterName);
                        }
                    },
                    {
                        label: 'DRIVER',
                        width: '150px',
                        viewName: 'driverName',
                        filterName: 'driverId',
                        sortName: 'driver.firstName',
                        filter: {
                            type: 'autoComplete',
                            placeholder: 'Search',
                            viewName: 'driverName',
                            filterBy: 'id',
                            items: [],
                            onSubmit: function (header) {
                                tableActions.sendRequest(tableActions.evaluateFilter(header));
                            },
                            refresh: function (model) {
                                const defer = $q.defer();
                                let filterItems = this.items;
                                FleetService.Drivers.getAll((data) => {
                                    filterItems.length = 0;
                                    angular.forEach(data.content, (driver) => {
                                        driver.driverName = driver.firstName + ' ' + driver.lastName;
                                        filterItems.push(driver);
                                    });
                                    defer.resolve();
                                }, (error) => {
                                    defer.reject();
                                }, { size: 30, firstName: model });
                                return defer.promise;
                            }
                        },
                        headerFn: function () {
                            tableActions.sort(this.sortName);
                        }
                    },
                    {
                        label: 'CONSIGNMENT',
                        viewName: 'consignmentId',
                        filterName: 'consignmentId',
                        filter: {
                            type: 'text',
                            onSubmit: function (header) {
                                tableActions.sendRequest(tableActions.evaluateFilter(header));
                            }
                        },
                        headerFn: function () {
                            tableActions.sort(this.filterName);
                        }
                    },
                    {
                        label: 'ORIGIN POSTCODE',
                        viewName: 'originPostcode',
                        filterName: 'sourceAddress.location.code',
                        filter: {
                            type: 'text',
                            onSubmit: function (header) {
                                tableActions.sendRequest(tableActions.evaluateFilter(header));
                            },
                        },
                        headerFn: function () {
                            tableActions.sort(this.filterName);
                        }
                    },
                    {
                        label: 'ORIGIN SUBURB',
                        viewName: 'originSuburb',
                        filterName: 'sourceAddress.location.name',
                        filter: {
                            type: 'text',
                            onSubmit: function (header) {
                                tableActions.sendRequest(tableActions.evaluateFilter(header));
                            },
                        },
                        headerFn: function () {
                            tableActions.sort(this.filterName);
                        }
                    },
                    {
                        label: 'DESTINATION POSTCODE',
                        viewName: 'destinationPostcode',
                        filterName: 'destinationAddress.location.code',
                        filter: {
                            type: 'text',
                            onSubmit: function (header) {
                                tableActions.sendRequest(tableActions.evaluateFilter(header));
                            },
                        },
                        headerFn: function () {
                            tableActions.sort(this.filterName);
                        }
                    },
                    {
                        label: 'DESTINATION SUBURB',
                        viewName: 'destinationSuburb',
                        filterName: 'destinationAddress.location.name',
                        filter: {
                            type: 'text',
                            onSubmit: function (header) {
                                tableActions.sendRequest(tableActions.evaluateFilter(header));
                            },
                        },
                        headerFn: function () {
                            tableActions.sort(this.filterName);
                        }
                    },
                    {
                        label: 'SOURCE ADDRESS',
                        viewName: 'formattedSourceAddress',
                    },
                    {
                        label: 'DESTINATION ADDRESS',
                        viewName: 'formattedDestinationAddress',
                    }
                ],
                data: [],
                resetFilters: () => {
                    tableActions.resetFilters();
                },
                onInit: function () {
                    tableActions.sendRequest();
                }
            }

            const tableActions = new TableLiteFactory(tableData, {
                serviceCallback: FleetService.RoutePlanning.getRoutePlanningAvailableJobs,
                callbackFormat: ['success', 'error', 'filter'],
                postRequestCallback: data => {
                    buildTableData(data);
                },
                postRequestErrorCallback: err => {
                    buildTableData(null);
                    toastr.error(err);
                },
                defaultFilters: {
                    size: 20,
                    sort: 'createdDate,desc',
                }
            });

            function buildTableData(data) {
                tableActions.initializeTableData(data);
                angular.forEach(data.content, (item) => {
                    const batch = item.batch || {};
                    const weightUnit = Units.getWeightUnit($rootScope.GlobalProfile.office.weightUnit);
                    const totalPackagesCubicWeightFormatted = `(${batch.totalPackagesCubicWeight} cm<sup>3</sup>)`;
                    const batchFormatted = (item.batchId === 0 || angular.isUndefined(item.batchId)) ? 'N/A (AD HOC Job)' : null;
                    let totalPackageWeight = 0;

                    item.dateTime = $filter('bbaDate')(item.createdDate, true);
                    item.jobStatusFormatted = jobStatuses[(item.jobStatus || 'unassigned').toLowerCase()];
                    item.driverName = `${angular.getObjVal(item, 'driver.firstName') || 'N/A'} ${angular.getObjVal(item, 'driver.lastName') || ''}`;
                    item.sortCode = angular.getObjVal(item, 'sortCode') || 'N/A';
                    item.companyName = angular.getObjVal(item, 'company.name');
                    item.batchFormatted = {
                        type: 'multiLine',
                        list: item.adhoc ? [batchFormatted] : [angular.getObjVal(item, 'batch.batchId'), `(${batch.totalJobsNumber} Jobs)`, totalPackagesCubicWeightFormatted, `(${totalPackageWeight} ${weightUnit})`]
                    };

                    item.originPostcode = angular.getObjVal(item, 'sourceAddress.location.code') || 'N/A';
                    item.originSuburb = angular.getObjVal(item, 'sourceAddress.location.name') || 'N/A';

                    item.destinationPostcode = angular.getObjVal(item, 'destinationAddress.location.code');
                    item.destinationSuburb = angular.getObjVal(item, 'destinationAddress.location.name');

                    item.scanSummary = ScanSummaryHelperService.getScanSummary(item.scanSummary);

                    item.formattedSourceAddress = parseAddress(item.sourceAddress);
                    item.formattedDestinationAddress = parseAddress(item.destinationAddress);

                    tableData.data.push(item);
                });
            }

            function parseAddress(address) {
                const { firstName, lastName, addressLine1, addressLine2, location } = address;
                const { country, state, name, code } = location;
                return `${firstName} ${lastName} ${addressLine1} ${addressLine2 || ''} ${name} ${state ? state.name : ''} ${code} ${country.code}`;
            }

            this.tableData = tableData;
        }
    }
})()


// WEBPACK FOOTER //
// ./js/services/tables/route-planning/RPJobAssignmentTable.js